import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsStockInfoDataStockDataCountTableItemCls: string;
		}
	},

	slug: string
}

class Data extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Stock Info Data Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '1', 'investors_stock_info_data', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '2', 'investors_stock_info_data', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '3', 'investors_stock_info_data', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '4', 'investors_stock_info_data', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '5', 'investors_stock_info_data', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoDataStockDataCountTableItemCls + '6', 'investors_stock_info_data', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Data;